var checkoutPage = document.querySelector(
  "body.page-checkout:not(.woocommerce-order-received)"
);

if (checkoutPage) {
  //Redirects to cart if user goes back from Thank You page
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.replace("/cart");
    }
  };
  document.addEventListener("DOMContentLoaded", function () {
    const hiddenBillingPhone = document.querySelectorAll(
      "input[name='billing_phone']"
    ) as NodeListOf<HTMLInputElement>;

    //Fix the paypal and phone number field conflict
    hiddenBillingPhone[1]?.remove();

    //Adds placeholders to the login form
    const addPlaceholders = () => {
      let username = <HTMLInputElement>(
        document.querySelector(".woocommerce-form-login #username")
      );
      let password = <HTMLInputElement>(
        document.querySelector(".woocommerce-form-login #password")
      );

      if (username) {
        username.placeholder = "Uporabniško ime";
      }

      if (password) {
        password.placeholder = "Geslo";
      }
    };

    /**
     * Observer for order summary section
     */
    let observerCheckout = new MutationObserver(observerCallbackCheckout);

    function setCheckoutObserver() {
      //Listens for cart form DOM changes
      let cartForm = document.querySelector("#order_review") as HTMLElement;
      if (cartForm) {
        observerCheckout.observe(cartForm, { childList: true });
      }
    }

    function observerCallbackCheckout() {
      let initialContainer = <HTMLTableElement>(
        document.querySelector(
          "body.page-checkout:not(.woocommerce-order-received) .woocommerce-checkout-review-order-table .order-total"
        )
      );

      const intervalOptions = <HTMLSelectElement>(
        document.getElementById("intervalOptions")
      );

      let copyContainer = <HTMLElement>(
        document.querySelector(".order-total-custom")
      );

      intervalOptions?.addEventListener("change", (e) => {
        document.body.dispatchEvent(new Event("update_checkout"));
        const ajaxData = (window as any).njamito_ajax;

        if ((window as any).njamito_ajax) {
          let data = new FormData();
          data.append("action", "njamito_set_cart_state_action");
          //data.append("activeSubscriptionScheme", intervalOptions.value);
          data.append("nonce", ajaxData.nonce);

          fetch(ajaxData.ajax_url, {
            method: "POST",
            body: data,
          })
            .then((response) => {
              return response.json();
            })
            .then((jsonResponse) => {
              if (!jsonResponse.success) {
                location.reload();
              }

              if (jsonResponse.success) {
                document.body.dispatchEvent(new Event("update_checkout"));
              }
            });
        }
      });

      // Copy order summary section
      if (copyContainer.innerHTML != undefined) {
        copyContainer.innerHTML = initialContainer.innerHTML;
      }

      setCheckoutObserver();
    }

    //Set form DOM change listener
    setCheckoutObserver();
    addPlaceholders();
  });
}
